// extracted by mini-css-extract-plugin
export default {"input":"_input_input__+RY5D","light":"_input_light__i0mAW","dark":"_input_dark__-Oq9V"};